import {
    LegacyFilmPlayerBaseInfoContent,
    LegacyVideoPlayerBaseInfoContent,
} from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { getMovieStartPosition } from '../../episode-player/utils/player';

import { getFilmPreviewData } from './get-film-preview';
import { getFilmSkippableFragments } from './get-film-skippable-fragments';

export const getFilmStartPosition = (
    filmOrVideo: LegacyFilmPlayerBaseInfoContent | LegacyVideoPlayerBaseInfoContent
) => {
    const skippableFragments = getFilmSkippableFragments(filmOrVideo);
    const filmPreview = getFilmPreviewData(filmOrVideo);

    let currentTime = 0;
    let duration = 1;

    if (filmPreview?.__typename === 'OttPreview_AbstractVideo') {
        if (filmPreview.duration) {
            duration = filmPreview.duration;
        }
        if (filmPreview.timing?.current) {
            currentTime = filmPreview.timing?.current;
        }
    }

    return getMovieStartPosition({ duration, currentTime, skippableFragments });
};
